import React, { useState } from 'react';
import { apiPut } from '../../API/Api_Url';
import { toast } from 'react-toastify';

function UpdateAgreementModal({ isOpen, onClose, agreementData, GetUserAllAgreementPendingRequirements }) {
    const [isLoading, setIsLoading] = useState(false);

    const onUpdate = async (status) => {
        try {
            setIsLoading(true);
            const data ={
                action:status
            }
            const response = await apiPut(`/api/user/UpdateUserAgreementRequest/${agreementData?._id}`, data);

            if (response?.data) {
                toast.success(`Agreement ${status.toLowerCase()} successfully!`);
                onClose();
                GetUserAllAgreementPendingRequirements();
            } else {
                toast.error(response?.message || "Failed to update agreement");
            }
        } catch (error) {
            console.error("Error updating agreement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div>
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-6">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                        Update Agreement
                    </h2>
                    <p className="text-gray-600 mb-6">
                        Are you sure you want to update the status of this agreement? This action cannot be undone.
                    </p>

                    <div className="flex justify-end gap-3">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => onUpdate('Rejected')}
                            disabled={isLoading}
                            className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 transition"
                        >
                            Reject
                        </button>
                        <button
                            onClick={() => onUpdate('Accepted')}
                            disabled={isLoading}
                            className="px-4 py-2 rounded-lg bg-green-500 text-white hover:bg-green-600 transition"
                        >
                            Accept
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateAgreementModal;